import React from 'react';
import './CreateChatbotModal.scss';
import chatbotGuySrc from 'assets/chatbot-guy-transparent.svg';

const CreateBotImageSection = () => (
  <div className="create-chatbot-modal__image-section">
    <div className="create-chatbot-modal__chatbot-guy-wrapper">
      <img src={chatbotGuySrc} alt="chatbot guy" />
    </div>
    <div className="create-chatbot-modal__image-title">Create a chatbot</div>
  </div>
);

export default CreateBotImageSection;
